import { createTheme, colors } from '@mui/material';

const primaryMain = 'rgba(100,100,230,1)';
const primaryLight = 'rgba(100,100,230,0.15)';
const secondaryMain = 'rgba(77,77,77,1)';
const divider = 'rgba(0,0,0,0.08)';
const defaultIconColor = 'rgba(0,0,0,0.54)';

export default createTheme({
  palette: {
    primary: {
      light: primaryLight,
      main: primaryMain
    },
    secondary: {
      main: secondaryMain
    },
    error: {
      light: colors.red[50],
      main: colors.red[600]
    },
    divider
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#f9f9f9'
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        margin: 'normal',
        fullWidth: true
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          border: 'none'
        }
      }
    },
    MuiContainer: {
      defaultProps: {
        disableGutters: true
      },
      styleOverrides: {
        root: {
          paddingRight: 16,
          paddingLeft: 16
        }
      }
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...((ownerState.variant === 'text' || ownerState.variant === 'outlined') && {
            '&:hover': {
              backgroundColor: primaryLight,
              color: primaryMain
            }
          }),
          ...((ownerState.color === 'inherit')) && {
            borderColor: divider,
            color: defaultIconColor,
            '&:hover': {
              backgroundColor: primaryLight,
              color: primaryMain
            }
          }
        })
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          borderRadius: 4,
          color: defaultIconColor,
          ...((ownerState.color === 'primary') && {
            backgroundColor: primaryLight,
            color: primaryMain
          }),
          ...((ownerState.color === 'error') && {
            '&:hover': {
              backgroundColor: colors.red[50],
              color: colors.red[600]
            }
          }),
          ...((ownerState.color === 'default' || ownerState.color === 'primary') && {
            '&:hover': {
              backgroundColor: primaryLight,
              color: primaryMain
            }
          })
        })
      }
    },
    MuiToolbar: {
      defaultProps: {
        disableGutters: true
      },
      styleOverrides: {
        root: {
          height: 48,
          backgroundColor: 'white',
          borderBottom: `1px solid ${divider}`,
          paddingRight: 16,
          paddingLeft: 16
        },
      }
    },
    MuiPaper: {
      defaultProps: {
        variant: 'outlined'
      },
      styleOverrides: {
        root: {
          borderColor: divider
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: divider
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          borderTopColor: divider,
          borderBottomColor: divider
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: primaryLight,
            color: primaryMain
          }
        }
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          color: defaultIconColor
        }
      }
    }
  },
  spacing: (factor:number) => `${factor * 0.25}rem`
});